import React from "react";

const ArrowLeft = ({canUndo, onClick}) => {
  return (
    <svg 
      width="25"
      height="25"
      viewBox="0 0 25 25"
      role="img" 
      aria-label="Press,To see previous pair from history."
      onClick={onClick}
      className={canUndo ? 'is-active' : ''}>
      <path d="M22.665 13.1a.75.75 0 0 1-.75.75H6.29l4.325 4.325a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225l-5.6-5.6a.762.762 0 0 1-.175-.25.734.734 0 0 1-.05-.275c0-.1.017-.192.05-.275a.762.762 0 0 1 .175-.25l5.6-5.6a.72.72 0 0 1 .525-.225c.2 0 .375.075.525.225a.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525L6.29 12.35h15.625a.75.75 0 0 1 .75.75Z"/>
      <title>Press,To see previous pair from history.</title>
    </svg>
  );
};

export default ArrowLeft;
